module.exports = __webpack_public_path__ + "nappcues_icon.svg";